"use client";

import Image from "next/image";
import React from "react";
import Counter from "./counter";
import { useInView } from "react-intersection-observer";
import { useTranslations } from "next-intl";
import { useParams } from "next/navigation";
import JoinNowButton from "./join-now-button";

const Separator = () => {
  const t = useTranslations("general");
  const [count, setCount] = React.useState(0);
  const {locale} = useParams()
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });
  const maxCount = 2405;

  React.useEffect(() => {
    let interval: NodeJS.Timeout;

    if (inView && count < maxCount) {
      interval = setInterval(() => {
        setCount((prevCount) => {
          const nextCount = prevCount + 1;
          return nextCount > maxCount ? maxCount : nextCount;
        });
      }, 1); // Adjust this value to change the speed of counting
    }

    return () => clearInterval(interval);
  }, [inView, count]);

  return (
    <section className="" ref={ref}>
      {/* separator */}
      {/* <div className="h-16 w-full bg-gradient-to-l from-primary to-second-primary "></div> */}
      {/* separator */}

      {/* waiting section */}
      <div className="flex flex-wrap justify-between items-center px-4 md:px-12 bg-black-bg text-primary-foreground">
        <div className={`space-y-4 md:w-[60%] ${locale === "ar" ? "md:text-right" : "md:text-left"}  text-center py-12 w-full`}>
          <h2 className="text-4xl md:text-6xl lg:text-7xl">
            {t("join_now")}
          </h2>
          <p className="text-white/80 md:w-3/4 w-full font-poppins text-xl capitalize">
            {t("waiting_description")}
          </p>
          <JoinNowButton />
        </div>
        <div className="md:w-[40%] w-full self-end">
          <Image
            src="/man3.png"
            alt="coach"
            width={400}
            height={400}
            className="w-full object-contain object-right-bottom"
          />
        </div>
        {/* <Counter count={count} t={t} /> */}
        {/* <div className="self-end text-4xl flex justify-center items-center gap-3">
          <span className="text-5xl md:text-7xl">2405</span>
          coach
        </div> */}
      </div>
      {/* waiting section */}

      {/* photo section */}
      {/* <div className="w-full h-64 hidden md:block">
        <Image
          src="/waiting-list.webp"
          alt="photo"
          width={2000}
          height={2000}
          className="object-cover w-full h-full"
          quality={100}
        />
      </div> */}
    </section>
  );
};

export default Separator;
